import { loadBaiduTracking } from '@/utils/baiduTracking';
import { loadSo360Tracking } from '@/utils/so360Tracking';
import { PageSetupOptions } from '../config/types';

export const setupPage = (options: PageSetupOptions = {}) => {
  if (options.documentTitle) {
    document.title = options.documentTitle;
  }
  if (options.baiduTracking) {
    loadBaiduTracking();
  }
  if (options.so360Tracking) {
    const siteId = typeof options.so360Tracking === 'number'
      ? options.so360Tracking
      : 629201;
    loadSo360Tracking(siteId);
  }
};
